/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_General_Auth_ErrorInputs */



/**
* | output |
* | --- |
* | "Authentication failed. Please try again or contact support." |
*
* @param {Auth_General_Auth_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_general_auth_error = /** @type {((inputs?: Auth_General_Auth_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_General_Auth_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Authentifizierungsfehler. Bitte versuche es erneut oder kontaktiere den Support.")
	return /** @type {LocalizedString} */ ("Authentication failed. Please try again or contact support.")
});